import { Typography } from "@material-ui/core";
import { OPERATION_STATUS } from "constants/status";
import React from "react";

const OperationTransactionColumn = ({ status }) => {
  const color = OPERATION_STATUS[status]?.color;
  const statusText = OPERATION_STATUS[status]?.text;

  return (
    <>
      {statusText && color ? (
        <Typography
          style={{
            color: color,
            borderRadius: "27px",
          }}
        >
          <b>{statusText}</b>
        </Typography>
      ) : (
        <Typography
          style={{
            borderRadius: "27px",
            textTransform: "uppercase",
            color: "#363636",
          }}
        >
          <b>{status}</b>
        </Typography>
      )}
    </>
  );
};

export default OperationTransactionColumn;
